var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.105 4.5l-2.33 1.77h4.89L6.408 7.916l3.213-.076 4.574-3.34H6.105zM5.73 8.412l3.11-.002.441-.322-3.105-.002-.446.326zM1.5 11.5h9.973l.892-1.77H7.032l1.504-1.098-3.01-.071L1.5 11.5z",
    fill: "#D70022"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3917_32776",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 14,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.105 4.5l-2.33 1.77h4.89L6.408 7.916l3.213-.076 4.574-3.34H6.105zM5.73 8.412l3.11-.002.441-.322-3.105-.002-.446.326zM1.5 11.5h9.973l.892-1.77H7.032l1.504-1.098-3.01-.071L1.5 11.5z",
    fill: "#fff"
  }))));
}
SvgZoom.displayName = 'Zoom';
export default SvgZoom;